<template>
  <div class="flex -mx-3">
    <div class="w-48 px-3">
      {{ $t('name') | capitalize }}
    </div>
    <div class="flex-1 px-3">
      {{ $t('description') | capitalize }}
    </div>
    <div class="w-48 px-3">
      {{ $t('scope') | capitalize }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
